import { NavLink, useLocation } from 'react-router-dom'

export default function SidebarLink({
  to,
  icon,
  label,
  match,
}: {
  to: string
  icon: React.ReactNode
  label: string
  // Extra path prefixes that should also mark this link active (e.g. the
  // Collections link staying lit on a `/collection/:id` detail page).
  match?: string[]
}) {
  const { pathname } = useLocation()
  const matchActive =
    match?.some((p) => pathname === p || pathname.startsWith(`${p}/`)) ?? false

  return (
    <NavLink
      to={to}
      className={({ isActive }) =>
        `nav-item flex items-center gap-3 px-3 py-2.5 rounded-xl font-semibold text-sm transition-colors ${
          isActive || matchActive
            ? 'bg-terracotta/10 text-terracotta active'
            : 'text-ink-soft hover:bg-surface-2 hover:text-ink'
        }`
      }
    >
      {icon}
      {label}
    </NavLink>
  )
}
